var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heartbeat-trace",class:[_vm.tone, { compact: _vm.compact }],attrs:{"aria-hidden":"true"}},[_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }